<section class="location-picker" aria-labelledby="location-picker-title">
  <div class="location-picker__header">
    <div>
      <h3 id="location-picker-title">{{ 'locationPicker.title' | translate }}</h3>
      <p id="location-picker-instructions">
        {{ 'locationPicker.instructions' | translate }}
      </p>
    </div>
    <button
      type="button"
      class="location-picker__secondary-action"
      [disabled]="isLocating()"
      (click)="useCurrentLocation()"
    >
      {{
        (isLocating()
          ? 'locationPicker.locating'
          : 'locationPicker.useCurrentLocation'
        ) | translate
      }}
    </button>
  </div>

  <div
    #mapHost
    class="location-picker__map"
    role="application"
    tabindex="0"
    [attr.aria-label]="'locationPicker.mapLabel' | translate"
    aria-describedby="location-picker-instructions"
    (keydown.enter)="selectMapCenter()"
  ></div>

  <div class="location-picker__footer" aria-live="polite">
    <div>
      @if (selectedLatitude() !== null && selectedLongitude() !== null) {
        <p class="location-picker__coordinates">
          {{ selectedLatitude()!.toFixed(6) }}, {{ selectedLongitude()!.toFixed(6) }}
        </p>
        <p
          class="location-picker__status"
          [class.location-picker__status--confirmed]="confirmed()"
        >
          {{
            (confirmed()
              ? 'locationPicker.confirmed'
              : 'locationPicker.confirmRequired'
            ) | translate
          }}
        </p>
      } @else {
        <p class="location-picker__status">
          {{ 'locationPicker.noLocation' | translate }}
        </p>
      }
      @if (geolocationError(); as errorKey) {
        <p class="location-picker__error">{{ errorKey | translate }}</p>
      }
    </div>
    <button
      type="button"
      class="location-picker__confirm-action"
      [disabled]="
        selectedLatitude() === null || selectedLongitude() === null || confirmed()
      "
      (click)="confirmSelection()"
    >
      {{ 'locationPicker.confirmPin' | translate }}
    </button>
  </div>
</section>
